'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint no-undef: "off" */
/**
 * XPark product card
 */
define('xparkProductCard',['util', 'appStorage', 'addToWishlistApi', 'deleteWishlistApi', 'svgIcon', 'countDownTimer'], function (Util, appStorage, addToWishlistApi, deleteWishlistApi, svgIcon, Timer) {
  return {
    template: '\n      <div class="xp-product-card" :class="cardClass">\n        <a\n          class="xp-product-card-link"\n          :href="productUrl"\n          :aria-label="title"\n          @click="$emit(\'product-click\', product)"\n        >\n          <div class="xp-product-media">\n            <button\n              type="button"\n              class="xp-fav-btn"\n              :class="{\'is-active\': isWishlisted}"\n              @click.stop.prevent="toggleWishlist"\n            >\n              <svg-icon\n                :type="isWishlisted ? \'wishlistFilled\' : \'wishlist\'"\n                :color="isWishlisted ? \'#E50909\' : \'#FE3116\'"\n                width="22"\n                height="22"\n              ></svg-icon>\n            </button>\n            <div class="xp-product-tags" v-if="tags.length">\n              <span\n                v-for="tagItem in tags"\n                :key="tagItem.type"\n                class="xp-product-tag"\n                :class="\'xp-tag-\' + tagItem.type"\n              >\n                <svg-icon\n                  :type="tagItem.icon"\n                  :width="tagItem.iconWidth"\n                  :height="tagItem.iconHeight"\n                ></svg-icon>\n                <span v-text="tagItem.label"></span>\n              </span>\n            </div>\n            <img :src="image" />\n            <div v-if="showCountdown" class="xp-product-countdown" aria-label="Sale countdown">\n              <strong>Sale</strong>\n              <span class="xp-product-countdown-time">\n                <b v-text="countdown.h"></b>\n                <i>:</i>\n                <b v-text="countdown.m"></b>\n                <i>:</i>\n                <b class="is-last" v-text="countdown.s"></b>\n              </span>\n            </div>\n          </div>\n          <div class="xp-product-info">\n            <div>\n              <h3 v-text="title"></h3>\n              <p v-if="slogan" v-text="slogan"></p>\n              <div class="xp-rating" v-if="showRating">\n                <span\n                  v-for="star in 5"\n                  :key="star"\n                  :class="{\'is-on\': star <= Math.floor(rating)}"\n                ></span>\n                <b v-text="rating.toFixed(1)"></b>\n                <em v-text="\'(\' + reviews + \')\'"></em>\n              </div>\n            </div>\n            <div class="xp-product-footer">\n              <div class="xp-price-wrap">\n                <div class="xp-price">\n                  <template v-if="finalPriceHtml">\n                    <span v-html="finalPriceHtml"></span>\n                  </template>\n                  <template v-else>\n                    <span class="xp-price-symbol">&#8358;</span>\n                    <strong v-text="price"></strong>\n                  </template>\n                </div>\n                <div class="xp-old-price" v-if="hasOldPrice">\n                  <template v-if="oldPriceHtml">\n                    <span v-html="oldPriceHtml"></span>\n                  </template>\n                  <template v-else>\n                    <span>&#8358;</span>\n                    <del v-text="oldPrice"></del>\n                  </template>\n                </div>\n              </div>\n              <button v-if="showCart" type="button" class="xp-cart-btn" @click.stop.prevent="$emit(\'cart-click\', product)">\n                <svg-icon type="cart" width="18" height="18" color="#111111"></svg-icon>\n              </button>\n            </div>\n          </div>\n        </a>\n      </div>\n    ',
    props: {
      product: {
        type: Object,
        required: true
      },
      showRating: {
        type: Boolean,
        default: false
      },
      showCart: {
        type: Boolean,
        default: true
      },
      cardClass: {
        type: String,
        default: ''
      }
    },
    components: {
      svgIcon: svgIcon
    },
    data: function data() {
      return {
        isWishlisted: this.getWishlistStatus(this.product),
        wishlistItemId: this.getWishlistItemId(this.product),
        wishlistBusy: false,
        countdownTimer: null,
        timerObj: null,
        countdown: {
          h: '00',
          m: '00',
          s: '00'
        }
      };
    },

    watch: {
      product: function product(value) {
        this.isWishlisted = this.getWishlistStatus(value);
        this.wishlistItemId = this.getWishlistItemId(value);
        this.wishlistBusy = false;
        this.setupCountdown(value);
      }
    },
    computed: {
      title: function title() {
        return this.product.title || this.product.name || this.product.product_name || '';
      },
      slogan: function slogan() {
        return this.product.slogan || '';
      },
      image: function image() {
        return this.product.image || this.product.imgurl || this.product.product_image || '';
      },
      productUrl: function productUrl() {
        return this.product.url || this.product.url_link || this.product.product_url || this.product.product_link || 'javascript:void(0);';
      },
      tags: function tags() {
        var tags = [];
        if (this.product.new_icon) {
          tags.push({
            type: 'new',
            icon: 'new',
            label: 'NEW',
            iconWidth: 8,
            iconHeight: 8
          });
        }
        if (this.product.sale_icon) {
          tags.push({
            type: 'sale',
            icon: 'hot',
            label: 'ON SALE',
            iconWidth: 6,
            iconHeight: 8
          });
        }
        return tags;
      },
      rating: function rating() {
        return Number(this.product.rating || this.product.review_rating || 0);
      },
      reviews: function reviews() {
        return Number(this.product.reviews || this.product.number_of_review || 0);
      },
      price: function price() {
        return this.formatPrice(this.product.price || this.product.final_price || '');
      },
      oldPrice: function oldPrice() {
        return this.formatPrice(this.product.oldPrice || this.product.max_price || this.product.origin_price || '');
      },
      finalPriceHtml: function finalPriceHtml() {
        return this.product.final_price_label || '';
      },
      oldPriceHtml: function oldPriceHtml() {
        return this.shouldShowOldPrice ? this.product.max_price_label || this.product.origin_price_label || '' : '';
      },
      shouldShowOldPrice: function shouldShowOldPrice() {
        return parseFloat(this.product.max_price || this.product.origin_price || this.product.oldPrice || 0) > parseFloat(this.product.final_price || this.product.price || 0);
      },
      hasOldPrice: function hasOldPrice() {
        return Boolean(this.oldPriceHtml || this.oldPrice && this.shouldShowOldPrice);
      },
      productId: function productId() {
        return this.product.product_id || this.product.id || this.product.entity_id || '';
      },
      loginUrl: function loginUrl() {
        return window.commonDataJSON && window.commonDataJSON.login_url || '/customer/account/login';
      },
      flashSaleBlock: function flashSaleBlock() {
        var block = this.product && this.product.block;
        if (!block || Array.isArray(block) || (typeof block === 'undefined' ? 'undefined' : _typeof(block)) !== 'object') {
          return null;
        }

        return block.block === 'flash_sales' ? block : null;
      },
      flashSaleFields: function flashSaleFields() {
        if (!this.product || this.product.flash_sales !== true) {
          return null;
        }

        return this.product;
      },
      countdownStartTime: function countdownStartTime() {
        return this.getTimestamp(this.flashSaleBlock && this.flashSaleBlock.start_date || this.flashSaleFields && this.flashSaleFields.start_date);
      },
      countdownEndTime: function countdownEndTime() {
        return this.getTimestamp(this.flashSaleBlock && this.flashSaleBlock.end_date || this.flashSaleFields && this.flashSaleFields.end_date);
      },
      showCountdown: function showCountdown() {
        return this.countdownEndTime > this.countdownStartTime && this.timerObj && this.timerObj.runTimer;
      }
    },
    mounted: function mounted() {
      this.setupCountdown(this.product);
    },
    beforeDestroy: function beforeDestroy() {
      this.clearCountdown();
    },

    methods: {
      formatPrice: function formatPrice(price) {
        return String(price || '').replace(/^₦\s*/, '');
      },
      getTimestamp: function getTimestamp(time) {
        var numericTime = Number(time);

        if (numericTime) {
          return numericTime > 9999999999 ? numericTime : numericTime * 1000;
        }

        return time ? new Date(String(time).replace(/-/g, '/')).getTime() : 0;
      },
      syncCountdownDisplay: function syncCountdownDisplay() {
        if (!this.timerObj) {
          this.countdown = {
            h: '00',
            m: '00',
            s: '00'
          };
          return;
        }

        var dayHours = Number(this.timerObj.d || 0) * 24;
        var hours = Math.min(99, Number(this.timerObj.h || 0) + dayHours);

        this.countdown = {
          h: String(hours).padStart(2, '0'),
          m: String(this.timerObj.m || '00').padStart(2, '0'),
          s: String(this.timerObj.s || '00').padStart(2, '0')
        };
      },
      tickCountdown: function tickCountdown() {
        var _this = this;

        if (!this.timerObj) {
          return;
        }

        this.timerObj.run().then(function (timer) {
          _this.timerObj = timer;
          _this.syncCountdownDisplay();

          if (!timer.runTimer) {
            _this.clearCountdown();
          }
        });
      },
      clearCountdown: function clearCountdown() {
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      },
      setupCountdown: function setupCountdown(product) {
        var _this2 = this;

        this.clearCountdown();
        this.timerObj = null;
        this.countdown = {
          h: '00',
          m: '00',
          s: '00'
        };

        var block = product && product.block && !Array.isArray(product.block) && _typeof(product.block) === 'object' ? product.block : null;
        var flashSaleFields = product && product.flash_sales === true ? product : null;
        var startTime = this.getTimestamp((block && block.block === 'flash_sales' ? block.start_date : 0) || flashSaleFields && flashSaleFields.start_date);
        var endTime = this.getTimestamp((block && block.block === 'flash_sales' ? block.end_date : 0) || flashSaleFields && flashSaleFields.end_date);

        if (!startTime || !endTime || endTime <= startTime) {
          return;
        }

        this.timerObj = new Timer(startTime, endTime);
        this.syncCountdownDisplay();

        if (!this.timerObj.runTimer) {
          return;
        }

        this.countdownTimer = setInterval(function () {
          _this2.tickCountdown();
        }, 1000);
      },
      getWishlistStatus: function getWishlistStatus(product) {
        return Boolean(product.is_in_wishlist || product.in_wishlist);
      },
      getWishlistItemId: function getWishlistItemId(product) {
        return product.wishlist_item_id || product.wishlistItemId || product.item_id || '';
      },
      setWishlistState: function setWishlistState(isWishlisted) {
        var wishlistItemId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        this.isWishlisted = isWishlisted;
        this.wishlistItemId = wishlistItemId;
        this.product.is_in_wishlist = isWishlisted ? 1 : 0;
        this.product.liked = isWishlisted;
        this.product.wishlist_item_id = wishlistItemId;
        this.$emit('wishlist-change', {
          product: this.product,
          isWishlisted: isWishlisted,
          wishlistItemId: wishlistItemId
        });
      },
      resolveWishlistItemId: function resolveWishlistItemId(resData) {
        var data = resData && (resData.data || resData);
        return data && (data.wishlist_item_id || data.wishlistItemId || data.item_id || data.id) || this.wishlistItemId;
      },
      toggleWishlist: function toggleWishlist() {
        var _this3 = this;

        if (this.wishlistBusy) {
          return false;
        }
        if (!appStorage.get('token')) {
          return Util.redirect(this.loginUrl);
        }
        if (!this.productId) {
          return false;
        }

        this.wishlistBusy = true;

        if (this.isWishlisted && !this.wishlistItemId) {
          this.wishlistBusy = false;
          return false;
        }

        if (this.isWishlisted) {
          return deleteWishlistApi({
            item_id: this.wishlistItemId
          }).then(function () {
            _this3.setWishlistState(false);
            _this3.wishlistBusy = false;
          }, function () {
            _this3.wishlistBusy = false;
          });
        }

        return addToWishlistApi({
          product_id: this.productId
        }).then(function (resData) {
          _this3.setWishlistState(true, _this3.resolveWishlistItemId(resData));
          _this3.wishlistBusy = false;
        }, function () {
          _this3.wishlistBusy = false;
        });
      }
    }
  };
});
